// The views of the Packets page: the live feed, the Decode tool and the Traces list.
export type PacketsView = "feed" | "decode" | "traces";

/** Where each view lives. */
export function packetsViewHash(v: PacketsView): string {
  return v === "decode" ? "#/packets/decode" : v === "traces" ? "#/packets/traces" : "#/packets";
}

export function PacketsViewSwitch({ active, onSelect }: { active: PacketsView; onSelect: (v: PacketsView) => void }) {
  return (
    <div className="theme-toggle" role="group" aria-label="Packets view" style={{ marginBottom: 10 }}>
      <button data-active={active === "feed"} onClick={() => onSelect("feed")}>
        Feed
      </button>
      <button data-active={active === "decode"} onClick={() => onSelect("decode")}>
        Decode
      </button>
      <button data-active={active === "traces"} onClick={() => onSelect("traces")}>
        Traces
      </button>
    </div>
  );
}
